// src/components/ActiveLawsuits.jsx
import Reveal from "./Reveal";
import { Link } from "react-router-dom";

const FALLBACK_IMG =
  "https://images.unsplash.com/photo-1521185496955-15097b20c5fe?q=80&w=1400&auto=format&fit=crop";

const SECTIONS = [
  {
    key: "dangerous-products",
    title: "Dangerous & Defective Products",
    items: [
      {
        slug: "baby-formula-nec",
        title: "Baby Formula NEC Lawsuits",
        img: "/tort/nec.jpg",
        sub: "NEC (necrotizing enterocolitis) in premature infants.",
        desc: "Was a premature baby fed cow’s-milk–based formula or fortifier and later diagnosed with NEC? You may be eligible. Fast, confidential review—no upfront fees.",
      },
    ],
  },
  {
    key: "toxic-exposure",
    title: "Exposure to Toxic Substances",
    items: [
      {
        slug: "roundup-cancer",
        title: "RoundUp Cancer Lawsuits",
        img: "/tort/roundup.jpg",
        sub: "Exposure to glyphosate linked to cancers.",
        desc: "Used RoundUp at home or work and now facing cancer? If you have a non-Hodgkin’s lymphoma diagnosis, you may be eligible. Free 2-minute review.",
      },
      {
        slug: "hair-relaxer-cancer",
        title: "Chemical Hair Relaxers and Straighteners Cancer",
        img: "/tort/hair-relaxer.jpg",
        sub: "Use tied to increased cancer risk.",
        desc: "Years of chemical straighteners and a recent uterine/ovarian cancer diagnosis? Ongoing lawsuits link long-term use to higher risk. Quick, confidential eligibility check.",
      },
      {
        slug: "paraquat-parkinsons",
        title: "Paraquat Herbicide Lawsuits",
        img: "/tort/paraquat.jpg",
        sub: "Herbicide exposure linked to Parkinson’s.",
        desc: "Worked around paraquat or near spraying and later developed Parkinson’s? You may have a claim. Fast, no-cost review—deadlines apply.",
      },
      {
        slug: "asbestos-lung-cancer",
        title: "Lung Cancer Asbestos Lawsuit",
        img: "/tort/asbestos.jpg",
        sub: "Asbestos exposure (lung cancer only).",
        desc: "Asbestos exposure with a lung-cancer diagnosis? You may be eligible—even if you smoked. Confidential review with no upfront fees.",
      },
      {
        slug: "pfas-water",
        title: "PFAS Water Contamination Lawsuits",
        blurb: "‘Forever chemicals’ exposure claims.",
        img: "/tort/pfas.jpg",
        desc: "Drank or lived with PFAS-tainted water and later developed health issues? Find out if you qualify. Fast, confidential review—no upfront fees.",
      },
      {
        slug: "la-wildfire",
        title: "Los Angeles Wildfire",
        blurb: "Property loss and smoke injuries.",
        img: "/tort/wildfire.jpg",
        desc: "Home or business damaged—or smoke-related health issues—from recent wildfires? You may be eligible for compensation. Free 2-minute case check.",
      },
      {
        slug: "silicosis",
        title: "Silicosis Lawsuit",
        blurb: "Lung disease from silica dust exposure.",
        img: "/tort/silicosis.jpg",
        desc: "Diagnosed with silicosis after silica dust exposure? Check eligibility for a free legal review.",
      },
    ],
  },
  {
    key: "drugs-devices",
    title: "Defective Drugs & Medical Devices",
    items: [
      {
        slug: "oxbryta",
        title: "Oxbryta Lawsuits",
        blurb: "Safety concerns under review.",
        img: "/tort/oxbryta.jpg",
        desc: "Experienced serious side effects after taking Oxbryta? Speak with our network to check eligibility. Quick, confidential review.",
      },
      {
        slug: "bard-powerport",
        title: "Bard PowerPort Catheter Lawsuits",
        blurb: "Catheter fracture/migration claims.",
        img: "/tort/port-catheter.jpg",
        desc: "PowerPort fracture, migration, or infection after implantation? You may have a claim. Start a free, no-obligation review today.",
      },
      {
        slug: "hernia-mesh",
        title: "Hernia Mesh Lawsuits",
        blurb: "Failure, pain, and revision surgery.",
        img: "/tort/hernia-mesh.jpg",
        desc: "Pain, failure, or revision surgery after hernia mesh? See if you qualify for compensation. No cost to start; deadlines may apply.",
      },
      {
        slug: "ozempic-wegovy",
        title: "Ozempic and Wegovy Lawsuits",
        blurb: "Severe GI issues and complications.",
        img: "/tort/ozempic.jpg",
        desc: "Severe GI complications or hospitalizations after GLP-1 use? You could be eligible. Get a fast, private case review.",
      },
      {
        slug: "depo-provera",
        title: "Depo Provera Lawsuits",
        blurb: "Potential long-term side effects.",
        img: "/tort/depo2.jpg",
        desc: "Long-term side effects after Depo-Provera injections? Check your options in minutes. $0 upfront.",
      },
      
      {
  slug: "dupixent",
  title: "Dupixent Lawsuit",
  blurb: "Eye inflammation and severe reactions.",
  img: "/tort/dupixent.jpg",
  desc: "Issues after using Dupixent? Check eligibility in minutes — confidential review.",
      },
    ],
  },
  {
    key: "injury-disability",
    title: "Injury & Disability",
    items: [
      {
        slug: "auto-accident-personal-injury",
        title: "Auto Accident and Personal Injury Lawsuits",
        blurb: "Get help after crashes and injuries.",
        img: "/tort/auto.jpg",
        desc: "Injured in a crash? Medical bills, lost wages, or pain and suffering may be compensable. Free case evaluation.",
      },
      {
        slug: "ssdi-applications",
        title: "Social Security Disability Benefits (SSDI) Applications",
        blurb: "Help filing for disability benefits.",
        img: "/tort/ssdi.jpg",
        desc: "Denied or filing SSDI? Get help building a strong claim and paperwork. Quick assessment to see if you qualify.",
      },
      {
        slug: "birth-injury",
        title: "Birth Injury Lawyers",
        blurb: "Negligence causing birth injuries.",
        img: "/tort/birth.jpg",
        desc: "Suspect negligence during labor or delivery? Explore legal options for your child’s care. Free, compassionate review.",
      },
      {
        slug: "video-game-addiction",
        title: "Video Game Addiction Lawsuits",
        blurb: "Compulsive use harms in youth.",
        img: "/tort/video-game.jpg",
        desc: "Compulsive gaming harming health, school, or behavior? See if your family may have a claim. Confidential guidance.",
      },
    ],
  },
  {
    key: "abuse",
    title: "Physical & Sexual Abuse",
    items: [
      {
        slug: "lds-abuse",
        title: "LDS Mormon Church Abuse Lawsuit",
        blurb: "Confidential claims for survivors.",
        img: "/tort/lds2.jpg",
        desc: "Survivors can seek accountability and support. Your story stays confidential. Learn about options and timelines.",
      },
      {
        slug: "roblox-discord-child-abuse",
        title: "Roblox & Discord Child Abuse Lawsuit",
        blurb: "Online platforms and child safety.",
        img: "/tort/roblox1.jpg",
        desc: "Online grooming, sextortion, or in-person harm following contact on these platforms? Parents: see your legal options. Private, urgent review.",
      },
      {
        slug: "rideshare-assault",
        title: "Rideshare Abuse and Assault Lawsuits",
        blurb: "Uber/Lyft passenger safety claims.",
        img: "/tort/rideshare.jpg",
        desc: "Assault or abuse during a rideshare trip—driver or passenger? You may be eligible for compensation. Free, confidential consultation.",
      },

      {
        slug: "snapchat-addiction",
        title: "Snapchat Addiction Lawsuit",
        blurb: "Mental health and social media harm.",
        img: "/tort/snapchat-addiction.jpg",
        desc: "Social media addiction linked to Snapchat use? Learn whether you qualify for a confidential case review.",
      },
    ],
  },
];

function SectionTitle({ children }) {
  return (
    <div className="mb-8">
      <h3 className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#0A2540]">
        {children}
      </h3>
      <div className="mt-2 h-1.5 w-20 rounded-full bg-[#C89B3C]/90" />
    </div>
  );
}

/** Card (headings thicker; sub/blurb clamp=2; desc clamp=3; CTAs pinned) */
function Card({ item }) {
  const img = item.img || FALLBACK_IMG;

  return (
    <article
      className="
        h-full group rounded-2xl bg-white border border-slate-200 shadow-sm
        transition-all duration-300 hover:-translate-y-2
        hover:border-[#C89B3C] hover:ring-2 hover:ring-[#C89B3C]/35
        hover:shadow-[0_18px_50px_rgba(0,0,0,0.18)]
        flex flex-col
      "
    >
      <div className="h-48 w-full overflow-hidden rounded-t-2xl">
        <img
          src={img}
          alt={item.title}
          className="h-full w-full object-cover"
          loading="lazy"
          onError={(e) => (e.currentTarget.src = FALLBACK_IMG)}
        />
      </div>

      <div className="p-5 flex-1 flex flex-col">
        {/* thicker heading */}
        <h4 className="text-lg md:text-xl font-bold text-[#0A2540] leading-snug">
          {item.title}
        </h4>

        {/* prefer sub, else blurb (clamped to 2 lines) */}
        {item.sub && (
          <p className="mt-2 text-slate-600 text-base [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical] overflow-hidden">
            {item.sub}
          </p>
        )}
        {!item.sub && item.blurb && (
          <p className="mt-1 text-sm text-slate-600 leading-relaxed [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical] overflow-hidden">
            {item.blurb}
          </p>
        )}

        {/* 2–3 line live desc (clamped to 3) */}
        {item.desc && (
          <p className="mt-3 text-slate-700 text-sm leading-6 [display:-webkit-box] [-webkit-line-clamp:3] [-webkit-box-orient:vertical] overflow-hidden">
            {item.desc}
          </p>
        )}

        {/* CTAs pinned to bottom */}
        <div className="mt-auto pt-5 flex flex-wrap items-center gap-3">
          <Link
            to={`/lawsuits/${item.slug}`}
            state={{ caseTitle: item.title }}
            className="rounded-full bg-[#C89B3C] px-5 py-3 text-sm font-semibold text-white shadow hover:opacity-90 transition"
          >
            Join Today
          </Link>
          <Link
            to={`/lawsuits/${item.slug}`}
            state={{ caseTitle: item.title }}
            className="rounded-full border border-[#0A2540] px-5 py-3 text-sm font-medium text-[#0A2540] hover:bg-[#0A2540] hover:text-white transition"
          >
            Read More
          </Link>
        </div>
      </div>
    </article>
  );
}

export default function ActiveLawsuits() {
  return (
    <section id="active-lawsuits" className="relative overflow-hidden py-16">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div
          className="absolute inset-0"
          style={{
            background: `
              radial-gradient(700px 400px at 0% 0%, rgba(236, 186, 163, 0.28) 0%, rgba(236,186,163,0) 60%),
              radial-gradient(800px 450px at 100% 0%, rgba(196, 210, 255, 0.28) 0%, rgba(196,210,255,0) 60%),
              linear-gradient(180deg, #FFFFFF 0%, #F7F3EC 40%, #FFFFFF 100%)
            `,
            backgroundBlendMode: "screen, screen, normal",
          }}
        />
      </div>

      <div className="mx-auto max-w-screen-2xl px-6 relative z-10">
        <p className="mx-auto mb-4 w-fit rounded-full bg-[#EAD8B6]/60 px-4 py-1 text-sm">
          Active Lawsuits
        </p>
        <h2 className="text-6xl md:text-4xl font-extrabold tracking-tight text-[#0A2540] text-center">
          Explore Ongoing Mass-Tort Investigations
        </h2>
        <p className="mt-2 text-center text-slate-600 text-sm">
          No upfront fees · 100% confidential · Quick eligibility check
        </p>

        <div className="mt-10 space-y-14">
          {SECTIONS.map((section) => (
            <div key={section.key}>
              <SectionTitle>{section.title}</SectionTitle>

              <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {section.items.map((item) => (
                  <Reveal key={item.slug}>
                    <Card item={item} />
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
